// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB0XaklHtyE0e5TB1O2zyKf1mpfpDyjrhg",
    authDomain: "rentalapp-f587c.firebaseapp.com",
    databaseURL: "https://rentalapp-f587c.firebaseio.com",
    projectId: "rentalapp-f587c",
    storageBucket: "rentalapp-f587c.appspot.com",
    messagingSenderId: "332159489397",
    appId: "1:332159489397:web:9a1b2b417afb6484"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
